import { Box, Stack } from '@mantine/core'
import {
  RouteHeaderLabel,
  type RouteHeaderLabelTone,
} from '~/boggle/ui/atoms/Labels'
import { ChallengeScoreTargetsHud } from '~/boggle/ui/challenge/ChallengeScoreTargets'

const trayShellByTone: Record<
  Exclude<RouteHeaderLabelTone, 'neutral'>,
  { background: string; border: string }
> = {
  challenge: {
    background: 'rgba(240, 163, 92, 0.08)',
    border: '1px solid rgba(240, 163, 92, 0.32)',
  },
  practice: {
    background: 'rgba(32, 101, 98, 0.18)',
    border: '1px solid rgba(109, 209, 204, 0.26)',
  },
}

/**
 * Top-right chrome: contextual **Challenge** / **Practice** label with score thresholds + best underneath.
 */
export function ChallengeContextScoreTray({
  aceScore,
  bestScore,
  contextLabelClick,
  mode,
  targetScore,
}: {
  aceScore?: number
  bestScore: null | number
  /** When set (e.g. during a run), the label is clickable to return to staging/reveal */
  contextLabelClick?: () => void
  mode: 'challenge' | 'practice'
  targetScore?: number
}) {
  const label = mode === 'practice' ? 'Practice' : 'Challenge'
  const tone: RouteHeaderLabelTone = mode === 'practice' ? 'practice' : 'challenge'

  const hasTargets = typeof aceScore === 'number' && typeof targetScore === 'number'

  const hud = (
    <ChallengeScoreTargetsHud
      aceScore={aceScore}
      bestScore={bestScore}
      targetScore={targetScore}
      trimBottomSpacing
    />
  )

  if (!hasTargets && bestScore === null) {
    return null
  }

  const shell = trayShellByTone[tone]

  return (
    <Box
      bdrs={12}
      px={12}
      pb={16}
      pos="relative"
      top={-20}
      mt={4}
      mr={10}
      style={{
        background: shell.background,
        border: shell.border,
        width: 'fit-content',
      }}
    >
      <Stack align="center" gap={6} miw={0} pt={18}>
        <Box px={12}>
          <RouteHeaderLabel onClick={contextLabelClick} text={label} tone={tone} />
        </Box>
        {hud}
      </Stack>
    </Box>
  )
}
